import { isBeta, isStage } from "astrid-helpers/src/env";

import Label from "../../../ui/components/Label/Label";

export default function EnvironmentLabel() {
	if (!isBeta && !isStage) {
		return null;
	}

	return (
		<Label size="small" color={isBeta ? "orange" : "red"}>
			{isBeta ? "Beta" : "Stage"}
		</Label>
	);
}
